import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  CorrectionData: {},
};

const viewCorrectionSlice = createSlice({
  name: "viewCorrection",
  initialState,
  reducers: {
    fetchCorrectionData(state, action) {
      state.CorrectionData = {};
    },
    fetchCorrectionDataSuccess(state, action) {
      state.CorrectionData = action.payload.data;
    },
    fetchCorrectionDataFailure(state, action) {
      state.CorrectionData = {};
    },
  },
});

export const { actions, reducer, name: sliceKey } = viewCorrectionSlice;
